import React, { useEffect, useState } from "react";
import {
    Autocomplete,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import styled from "styled-components";
import { ACTIVITY_STATUS } from "../../constants";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";

const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const StyledDialog = styled(Dialog)`
  // position: relative;
  // max-width: 700px;
  
`;  

  const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
    `;
  
  
  const DeclarationPaymentModal = ({ onCancel, items , onSubmit }) => {
    // console.log("ssdasd",items)
    const [form, setForm] = useState({
     payment: items.payment || '',
     declaration: items.declaration || false
    });
const [loading,setLoading] = useState(false)
     // useEffect(()=>{
    //   console.log("Customer Name",customerData)
    // },[customerData])
    // console.log("customerdata", initialData)
  
    const changeHandler = (fieldName, value) => {
      setForm((prevForm) => ({ ...prevForm, [fieldName]: value }));
    };
  
    const submitHandler = () => {
        setLoading(true);
        // if(!form.invoiceNo.length)
        // window.NotificationUtils.showError("Invoice number is required")
        // else{
        onSubmit({payment: form.payment,id: items.id, declaration: form.declaration})
        // console.log(form)
        setLoading(false)
        onCancel()
    // }
    //   console.log({...form, supplierName: initialData.SupplierName});
    // if(form.remark && form.typeOfShipment)
    //   onSubmit({...form})
    //   else
    //   window.NotificationUtils.showError("Please fill all the fields")
    };
    const options = [ { value: 'Air', label: 'Air' },
    { value: 'Sea', label: 'Sea' },
  ]
  
    return (
      <StyledDialog disableEnforceFocus maxWidth="xs" fullWidth={true} open={true}>
      <StyledDialogContent>
        <ModalHeaderContainer>
          <Typography variant="h5">Update Details</Typography>

          <IconButton disabled={loading} onClick={onCancel}>
            <CloseOutlined />
          </IconButton>
        </ModalHeaderContainer>
          {/* <Typography variant="h10">Supplier Name: {initialData.SupplierName}</Typography> */}
        {/* <DialogContent style={{ padding: "10px", width: 400 }}> */}
          <Stack gap="10px" style={{ padding: "10px", marginBottom:'10px' }} direction='row'>
            {loading && <OpaqueLoading />}
            <Stack spacing={1}  >
                   <Typography >
                   <span style={{width: '300px'}}> Declaration Status:</span>
                    <Checkbox 
                    disabled={items.declaration}
                    checked={form.declaration || false}
                    // onClick={(e,val)=> console.log(e.target.checked)}
                    onChange={(e) =>
                        changeHandler("declaration", e.target.checked)
                      }
                    />
                   </Typography>
                </Stack>
                <Stack >
                   <Typography>
                   <span style={{width: '500px'}}> Payment Status:</span>
                    <Checkbox 
                    disabled={items.payment}
                    checked={form.payment || false}
                    // onClick={(e,val)=> console.log(e.target.checked)}
                    onChange={(e) =>
                        changeHandler("payment", e.target.checked)
                      }
                    />
                   </Typography>
                </Stack>
          </Stack>
            <Stack
              direction="row"
              justifyContent="flex-end"
              gap="10px"
              align-items="center"
            >
              {/* <Button color="error" onClick={onCancel}>
                Close
              </Button> */}
              <Button
                color="primary"
                variant="contained"
                onClick={submitHandler}
                disabled={!form.payment||!form.declaration||loading}
              >
                Submit
              </Button>
            </Stack>
          </StyledDialogContent>
    </StyledDialog>
    );
  };
  
  export default DeclarationPaymentModal;
  